export {
  getMostPreferred,
  getPreferredLanguages,
  normalizeLocale,
  matches,
  currentLocale,
  usesEnglish,
} from './src/language';
export { supportedLocales } from './src/supported-locales';
